// External deps

import PropTypes from 'prop-types';
import { Button, Label } from 'ypf-pas-general-ui-components';
import { AiOutlineMinusCircle } from 'react-icons/ai';

// Internal deps
import './MonthlyApproversTable.scss';

const MonthlyApproversTable = ({ approvers, onDelete, canEdit }) => (
  <div className="monthly-approvers-table">
    <div className="monthly-approvers-table-header">
      <Label label="Aprobador" />
      <Label label="Equipo" />
      <Label label="Servicio" />
      <Label label="Contrato" />
    </div>
    {approvers?.map((approver, index) => (
      <div
        className={`monthly-approvers-table-row ${approvers.length - 1 !== index ? 'mb-3' : ''}`}
        key={approver?.id}
      >
        <div className="field text-truncate">{approver.nombre}</div>
        <div className="field text-truncate">{approver.equipoNombre}</div>
        <div className="field text-truncate">{approver.servicioNombre}</div>
        <div className="field text-truncate">{approver.contratoNumero}</div>
        {canEdit && (
          <Button
            className="delete-button"
            colorIcon="danger"
            disabled={!canEdit}
            icon={AiOutlineMinusCircle}
            onClick={() => onDelete(approver.id)}
            type="button"
            widthButton="40px"
          />
        )}
      </div>
    ))}
  </div>
);

export default MonthlyApproversTable;

MonthlyApproversTable.propTypes = {
  approvers: PropTypes.arrayOf(PropTypes.shape({})),
  onDelete: PropTypes.func,
  canEdit: PropTypes.bool
};

MonthlyApproversTable.defaultProps = {
  approvers: [],
  onDelete: () => {
    /* Empty */
  },
  canEdit: true
};
